@if (options() && options().length > 0) {
  @switch (state()) {
    @case ("DISPLAY") {
      <ng-container [ngTemplateOutlet]="displayState" />
    }
    @case ("CREATE") {
      <ng-container [ngTemplateOutlet]="createState" />
    }
  }
}

<ng-template #displayState>
  <app-badge
    class="display-form"
    [kind]="'PRIMARY'"
    [icon]="'plus'"
    [text]="badgeText()"
    [interactionMode]="'BUTTON'"
    [hotkeyAction]="createHotkey()"
    [actionDisabled]="disableHotkeys()"
    (actionTriggered)="toggleForm()"
    (badgeClick)="toggleForm()"
  ></app-badge>
</ng-template>

<ng-template #createState>
  <form class="form" (keydown.Escape)="onCancel()" (submit)="onSubmit($event)">
    <label [for]="id" class="cdk-visually-hidden">
      {{ formFieldLabel() }}
    </label>
    <app-typeahead
      [options]="options()"
      [labelProp]="labelProp()"
      [valueProp]="valueProp()"
      [id]="id"
      [placeholder]="formFieldLabel()"
      [selectedItem]="userModel"
      [autofocus]="true"
      (changed)="onChange($event)"
    />

    <!-- Submit Button -->
    <button
      btn
      class="mx-2"
      aria-label="submit form"
      [kind]="submitButtonType()"
      [size]="'SMALL'"
      [icon]="'check'"
      [type]="'submit'"
      [disabled]="userModel == null"
    ></button>

    <!-- Cancel Button -->
    <button
      btn
      aria-label="cancel form submission"
      [kind]="cancelButtonType()"
      [size]="'SMALL'"
      [icon]="'times'"
      [hotkeyAction]="'cancel'"
      [actionDisabled]="disableHotkeys()"
      (actionTriggered)="toggleForm()"
      (clicked)="toggleForm()"
    ></button>
  </form>
</ng-template>
